import { render, staticRenderFns } from "./PayrollList.vue?vue&type=template&id=4f56c390&scoped=true"
import script from "./PayrollList.vue?vue&type=script&lang=js"
export * from "./PayrollList.vue?vue&type=script&lang=js"
import style0 from "./PayrollList.vue?vue&type=style&index=0&id=4f56c390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56c390",
  null
  
)

export default component.exports